import fetch from 'isomorphic-fetch'

import {
  CHALLENGE_REQUEST,
  CHALLENGE_SUCCESS,
  CHALLENGE_FAILURE
} from '../actions'

import { userAssignmentPayload, getAPIendpointPrefix } from './apiHelper.js'

export default () => {
  return (dispatch, getState) => {
    const challengeQuestionValue = getState().core.uiState.challengeQuestionValue
    const challengeIssueType = getState().core.uiState.challengeIssueTypeValue
    const optionalEmail = getState().core.uiState.challengeEmailValue

    const activity = getState().core.activity

    let payload
    try {
      payload = userAssignmentPayload(activity)
    } catch (e) {
      return Promise.reject('cannot post challenge--missing required data')
    }

    let bookId = activity.bookId ? activity.bookId.trim() : ''
    if (bookId === 'https://ebooks.macmillanhighered.com/' || !bookId || !(!activity.lcrp)) {
      /* activity config files are of the example form: psych/LichtSciAm2e/3c__the_chemical_and_skin_sens_97BB12_ag
       * the following showuld give the bookId from the path (LichtSciAm2e) from the above example.
       * This format has been like this for 10 years, but if there are future bookId issues, this is a place
       * to check. See MLLC-993
       */
      const extractedBookId = activity.config.file ? activity.config.file.split('/')[1] : false
      if (extractedBookId) {
        bookId = extractedBookId
      }
    }

    payload = {
      ...payload,
      activity: activity.config.file || '',
      book_id: bookId,
      question_num: activity.score.curCard.questionIndex,
      question_id: activity.score.curCard.meta.fq_uid,
      question_text: activity.score.curCard.questionText.substr(0, 30) + '...',
      question_type: activity.score.curCard.questionType,
      comment: challengeQuestionValue,
      issue_type: challengeIssueType,
      user_email: optionalEmail
    }

    const payloadString = JSON.stringify(payload)

    dispatch({ type: CHALLENGE_REQUEST })

    return fetch(getAPIendpointPrefix() + 'api/v1/challenge_question.php',
      {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json; charset=utf-8' },
        body: payloadString
      })
      .then(response => {
        const contentType = response.headers.get('content-type')
        if (contentType && contentType.includes('application/json')) {
          return response.json()
        } else {
          return Promise.resolve({ error: 'unknown error' })
        }
      })
      .then(json => {
        return json.error
          ? dispatch({ type: CHALLENGE_FAILURE, payload: json })
          : dispatch({ type: CHALLENGE_SUCCESS, payload: json })
      })
  }
}
